import api from '@/assets/js/api.js'
import pusherManager from '../../assets/js/pusherManager'
import Vue from 'vue'
import {EventBus} from '@/assets/js/event-bus.js'

const state = {
  lines: [],
  currentLine: null,
  currentLineInSession: false,
  currentLiveCart: {
    cartItems: {
      data: []
    }
  },
  sessionMessages: [],
  inLivePage: false,
  checkLineStatus: false,
  currentSessionId: null,
  currentToken: null,
  sessionChannel: null,
  sessionUnexpectedClose: false,
  connecting: false,
  currentCart: {
    cartItems: {
      data: []
    }
  },
  cartItemCounter: 0,
  carts: {
    data: [],
    links: {
      next: null
    },
    meta: {}
  },
  orders: {
    data: [],
    links: {
      next: null
    },
    meta: {}
  },
  emptyCart: {
    cartItems: {
      data: []
    }
  },
  share: {
    video: true,
    audio: true
  },
  addresses: [],
  paymentMethods: [],
  newMessage: false,
  waitingForVendor: false,
  preExistentCall: null
}

const getters = {
  user_get_prexistent_call: state => {
    return state.preExistentCall
  },
  user_get_shareVideo: state => {
    return state.share.video
  },
  user_get_shareAudio: state => {
    return state.share.audio
  },
  user_new_message: state => {
    return state.newMessage
  },
  user_get_line: state => {
    return lineUid => {
      for (var l in state.lines) {
        if (state.lines[l].uid === lineUid) {
          return state.lines[l]
        }
      }
    }
  },
  user_get_in_live_page: state => {
    return state.inLivePage
  },
  user_get_lines: state => {
    return state.lines
  },
  user_get_current_line: state => {
    return state.currentLine
  },
  user_get_current_line_status: state => {
    return state.currentLineInSession
  },
  user_get_current_live_cart: state => {
    return state.currentLiveCart
  },
  user_get_current_live_cart_items: state => {
    return state.currentLiveCart.cartItems.data
  },
  user_get_carts: state => {
    return state.carts
  },
  user_get_orders: state => {
    return state.orders
  },
  user_get_cartItem_counter: state => {
    return state.cartItemCounter
  },
  user_get_session_messages: state => {
    return state.sessionMessages
  },
  user_connecting: state => {
    return state.connecting
  },
  user_session_unexpected_close: state => {
    return state.sessionUnexpectedClose
  },
  user_check_line_status: state => {
    return state.checkLineStatus
  },
  user_get_session_shop: state => {
    return state.currentLine ? state.currentLine.shop : null
  },
  user_get_session_id: state => {
    return state.currentLine ? state.currentLine.tokbox_session : ''
  },
  user_get_session_token: state => {
    return state.currentLine ? state.currentLine.token_user : ''
  },
  user_get_session_channel: state => {
    return state.sessionChannel
  },
  user_get_addresses: state => {
    return state.addresses
  },
  user_get_payment_details: state => {
    return state.paymentMethods
  },
  user_get_waiting_vendor: state => {
    return state.waitingForVendor
  }
}

const mutations = {
  USER_SET_IN_LIVE_PAGE (state, value) {
    state.inLivePage = value
  },
  USER_SET_PAYMENT_DETAILS (state, paymentMethods) {
    state.paymentMethods = paymentMethods
  },
  USER_ADD_PAYMENT_METHOD (state, paymentMethod) {
    var found = false
    for (var i in state.paymentMethods) {
      if (state.paymentMethods[i].uid === paymentMethod.uid) {
        found = true
        break
      }
    }
    if (!found) {
      Vue.set(state.paymentMethods, state.paymentMethods.length, paymentMethod)
    }
  },
  USER_RM_PAYMENT_METHOD (state, paymentMethod) {
    for (var i in state.paymentMethods) {
      if (state.paymentMethods[i].uid === paymentMethod.uid) {
        Vue.delete(state.paymentMethods, i)
        break
      }
    }
  },
  USER_SET_ADDRESSES (state, addresses) {
    state.addresses = addresses
  },
  USER_SET_LINES (state, lines) {
    state.lines = lines
    for (var l in state.lines) {
      var line = state.lines[l]
      pusherManager.initShopLinePositionListener(line.channels.shopline)
    }
  },
  USER_CALL_WAS_WAITING (state, lineUid) {
    state.preExistentCall = lineUid
  },
  USER_UPDATE_LINE (state, line) {
    for (var l in state.lines) {
      if (state.lines[l].uid === line.uid) {
        state.lines[l] = line
      }
    }
    if (state.currentLine && state.currentLine.uid === line.uid) {
      state.currentLine = line
    }
  },
  USER_UPDATE_LINE_INFO (state, line) {
    var foundLine = null
    for (var l in state.lines) {
      if (state.lines[l].uid === line.uid) {
        foundLine = state.lines[l]
        break
      }
    }
    if (foundLine) {
      for (var l2 in line) {
        foundLine[l2] = line[l2]
      }
    }
    if (state.currentLine && state.currentLine.uid === line.uid) {
      state.currentLine = foundLine
    }
  },
  USER_LINE_CHECK_STATUS (state, value) {
    state.checkLineStatus = value
  },
  USER_SHOP_SET_STATUS (state, event) {
    for (var l in state.lines) {
      if (state.lines[l].shop.uid === event.shop) {
        state.lines[l].shop.is_online = event.connectionStatus
      }
    }
    if (state.currentLine && state.currentLine.shop) {
      state.currentLine.shop.is_online = event.connectionStatus
    }
  },
  USER_SET_CURRENT_LINE (state, line) {
    if (line === null && state.currentLine) {
      EventBus.$emit('callStopped', state.currentLine)
    }
    state.currentLine = line
  },
  USER_VENDOR_LEFT_LINE (state, vendorUid) {
    for (var l in state.lines) {
      if (state.lines[l].vendor && state.lines[l].vendor.uid === vendorUid) {
        EventBus.$emit('callStopped', state.lines[l])
        Vue.set(state.lines[l], 'is_vendor_in_channel', false)
      }
    }
  },
  USER_SET_CURRENT_LINE_STATUS (state, status) {
    state.currentLineInSession = status
  },
  USER_SET_CURRENT_LINE_UNEXPECTED_CLOSE (state, value) {
    state.sessionUnexpectedClose = value
  },
  USER_SET_CURRENT_SESSION_CHANNEL (state, channel) {
    if (channel) {
      state.sessionChannel = channel
      if (state.currentLine && state.currentLine.channels) {
        state.currentLine.channels['salessession'] = channel
      }
    }
  },
  USER_SET_CURRENT_LIVE_CART (state, cart) {
    if (cart && cart.cartItems) {
      state.currentLiveCart = cart
    }
  },
  USER_SET_CARTS (state, carts) {
    state.carts = carts
  },
  USER_SET_ORDERS (state, orders) {
    state.orders = orders
  },
  USER_ORDER_PAGE (state, orders) {
    var data = state.orders.data.concat(orders.data)
    state.orders = {
      data: data,
      links: orders.links,
      meta: orders.meta
    }
  },
  USER_UPDATE_CART (state, payload) {
    Vue.set(state.carts.data, payload.index, payload.cart)
  },
  USER_REMOVE_CART (state, uid) {
    for (var c in state.carts.data) {
      if (state.carts.data[c].uid === uid) {
        Vue.delete(state.carts.data, c)
        break
      }
    }
  },
  USER_SET_CARTITEM_COUNTER (state) {
    var counter = 0
    state.carts.data.forEach((cart) => {
      console.log('CART', cart)
      cart.cartItems.data.forEach((cartItem) => {
        counter++
      })
    })
    state.cartItemCounter = counter
  },
  WAITING_FOR_VENDOR (state, waiting) {
    state.waitingForVendor = waiting
  },
  USER_SET_SHARE_VIDEO (state, share) {
    state.share.video = share
  },
  USER_SET_SHARE_AUDIO (state, share) {
    state.share.audio = share
  },
  USER_SESSION_STARTED (state) {
    state.currentLineInSession = true
    state.connecting = false
  },
  USER_START_SESSION (state) {
    pusherManager.sessionStarts()
  },
  USER_END_SESSION (state) {
    pusherManager.sessionEnds()
  },
  USER_CONNECTING (state, val) {
    state.connected = val
  },
  USER_SESSION_ENDED (state) {
    console.log('USER SESSION ENDED')
    state.currentLiveCart = state.emptyCart
    state.connecting = false
    state.currentLineInSession = false
    state.sessionMessages = []
    state.seenMessages = 0
  },
  USER_SET_SESSION_MESSAGES (state, messages) {
    state.sessionMessages = messages
    state.seenMessages = 0
  },
  USER_ADD_SESSION_MESSAGE (state, message) {
    state.sessionMessages.push(message)
  },
  USER_MESSAGE_CAME (state, value) {
    state.newMessage = value
  }
}

const actions = {
  resetPassword ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('resetPassword')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'resetPassword')
      api.resetPassword(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'resetPassword')
          console.log(response.data)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'resetPassword')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  resendVerificationLink ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('resendVerificationLink')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'resendVerificationLink')
      api.resendVerificationLink().then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'resendVerificationLink')
          console.log(response.data)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'resendVerificationLink')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  sendPasswordLink ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('sendPasswordLink')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'sendPasswordLink')
      api.sendPasswordLink(payload.email).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'sendPasswordLink')
          console.log(response.data)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'sendPasswordLink')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  updateUser ({ dispatch, commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('updateUser')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'updateUser')
      api.updateUser(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateUser')
          console.log(response.data)
          dispatch('getAuthAccount', payload)
          // if (payload.cb) {
          //   payload.cb(response)
          // }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateUser')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  updatePassword ({dispatch, commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('updatePassword')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'updatePassword')
      api.updatePassword(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updatePassword')
          console.log(response.data)
          if (payload.cb) {
            payload.cb(response)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updatePassword')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  getInLine ({ dispatch, commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getInLine')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getInLine')
      api.getInLine(payload.shop).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getInLine')
          console.log(response.data)
          dispatch('getLines', {})
          if (payload.cb) {
            payload.cb(response)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getInLine')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  getOutOfLine ({ dispatch, commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getOutOfLine')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getOutOfLine')
      api.getOutOfLine(payload.line).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getOutOfLine')
          console.log(response.data)
          dispatch('getLines', {})
          if (payload.cb) {
            payload.cb(response)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getOutOfLine')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  getLine ({ commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getLine')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getLine')
      api.getLine(payload.line).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getLine')
          console.log(response.data)
          commit('USER_UPDATE_LINE', response.data)
          if (payload && payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getLine')
          console.log(error)
          if (payload && payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  getLines ({ commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getLines')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getLines')
      api.getLines(1000).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getLines')
          console.log(response.data)
          commit('USER_SET_LINES', response.data)
          if (payload && payload.cb) {
            payload.cb(response)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getLines')
          console.log(error)
          if (payload && payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  getAddresses ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('getAddresses')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getAddresses')
      api.getAddresses(payload.userUid, 1000).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getAddresses')
          commit('USER_SET_ADDRESSES', response.data)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getAddresses')
          console.log(error)
        }
      )
    }
  },
  saveAddress ({dispatch, commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('saveAddress')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'saveAddress')
      api.saveAddress(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'saveAddress')
          dispatch('getAddresses', {userUid: payload.user})
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'saveAddress')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  updateAddress ({dispatch, commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('updateAddress')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'updateAddress')
      api.updateAddress(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateAddress')
          dispatch('getAddresses', {userUid: payload.user})
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateAddress')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  deleteAddress ({dispatch, commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('deleteAddress')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'deleteAddress')
      api.deleteAddress(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'deleteAddress')
          dispatch('getAddresses', {userUid: payload.user})
          if (payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'deleteAddress')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  getPaymentDetails ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('getPaymentDetails')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getPaymentDetails')
      api.getPaymentDetails(1000).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getPaymentDetails')
          commit('USER_SET_PAYMENT_DETAILS', response.data)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getPaymentDetails')
          console.log(error)
        }
      )
    }
  },
  savePaymentDetail ({commit, dispatch, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('savePaymentDetail')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'savePaymentDetail')
      api.savePaymentDetail(payload.hash, payload.token).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'savePaymentDetail')
          dispatch('getPaymentDetails', {})
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'savePaymentDetail')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  savePaymentDetailIntent ({commit, dispatch, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('savePaymentDetailIntent')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'savePaymentDetailIntent')
      api.savePaymentDetailIntent().then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'savePaymentDetailIntent')
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'savePaymentDetailIntent')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  standardPaymentDetail ({commit, dispatch, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('standardPaymentDetail')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'standardPaymentDetail')
      api.standardCardDetail(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'standardPaymentDetail')
          dispatch('getPaymentDetails', {})
          if (payload.cb) {
            payload.cb(response)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'standardPaymentDetail')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  deletePaymentDetail ({commit, dispatch, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('deletePaymentDetail')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'deletePaymentDetail')
      api.deletePaymentDetail(payload.uid).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'deletePaymentDetail')
          dispatch('getPaymentDetails', {})
          if (payload.cb) {
            payload.cb(response)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'deletePaymentDetail')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  getCurrentLiveCart ({ commit, dispatch, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getCurrentLiveCart')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getCurrentLiveCart')
      api.getCart(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getCurrentLiveCart')
          console.log(response.data)
          commit('USER_SET_CURRENT_LIVE_CART', response.data)
          dispatch('getChatMessages', {cart: response.data.uid})
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getCurrentLiveCart')
          console.log(error)
        }
      )
    }
  },
  getChatMessages ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('getChatMessages')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getChatMessages')
      api.getChatMessages(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getChatMessages')
          console.log('GET CHAT MESSAGES', response.data)
          commit('USER_SET_SESSION_MESSAGES', response.data)
          if (payload.cb) {
            payload.cb(response)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getChatMessages')
          console.log(error)
          if (payload.cb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  replaceCart ({commit, state, dispatch}, cart) {
    var found = false
    for (var c in state.carts.data) {
      if (state.carts.data[c].uid === cart.uid) {
        commit('USER_UPDATE_CART', {index: c, cart: cart})
        commit('USER_SET_CARTITEM_COUNTER')
        found = true
        break
      }
    }
    if (!found) {
      dispatch('getCarts', {user: cart.user.uid})
    }
  },
  getCarts ({ commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getCarts')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getCarts')
      console.log('GETTING CARTS...')
      api.getCarts(payload.user, 1000).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getCarts')
          commit('USER_SET_CARTS', response)
          commit('USER_SET_CARTITEM_COUNTER')
          if (payload.cb) {
            payload.cb(response)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getCarts')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  getOrders ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('getOrders')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getOrders')
      api.getOrders(payload.user, 12).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getOrders')
          commit('USER_SET_ORDERS', response)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getOrders')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  addItemToCart ({ commit, dispatch, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('addItemToCart')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'addItemToCart')
      api.addItemToCart(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'addItemToCart')
          console.log(response.data)
          dispatch('replaceCart', response.data)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'addItemToCart')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  updateItemFromCart ({ commit, dispatch, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('updateItemFromCart')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'updateItemFromCart')
      api.updateItemFromCart(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateItemFromCart')
          console.log(response.data)
          dispatch('replaceCart', response.data)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'updateItemFromCart')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  deleteItemFromCart ({ commit, dispatch, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('deleteItemFromCart')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'deleteItemFromCart')
      api.deleteItemFromCart(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'deleteItemFromCart')
          console.log(response.data)
          dispatch('getCarts', {user: payload.user})
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'deleteItemFromCart')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  deleteActiveCart ({ commit, dispatch, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('deleteActiveCart')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'deleteActiveCart')
      api.deleteActiveCart(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'deleteActiveCart')
          console.log(response.data)
          commit('USER_REMOVE_CART', payload.cart.uid)
          commit('USER_SET_CARTITEM_COUNTER')
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'deleteActiveCart')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  sessionStatus ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('sessionStatus')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'sessionStatus')
      api.sessionStatus(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'sessionStatus')
          commit('USER_UPDATE_LINE', response.data)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'sessionStatus')
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js